import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Badge, Box, Button, Callout, Card, Flex, Separator, Spinner, Tabs, Text } from "@radix-ui/themes";
import debounce from "lodash.debounce";
import { useCallback, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import CheckboxComponent from "../../components/inputs/Checkbox/CheckboxComponent";
import CheckboxGroupComponent from "../../components/inputs/CheckboxGroup/CheckboxGroupComponent";
import { DragAndDropFileUpload } from "../../components/inputs/FileUpload/DragAndDropFileUpload";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { useGetCurrentAcademicYearQuery } from "../../hooks/useGetCurrentAcademicYearQuery";
import { useGetPaymentTypesQuery } from "../../hooks/useGetPaymentTypesQuery";
import { useGetScholarshipsQuery } from "../../hooks/useGetScholarshipsQuery";
import { useGetSchoolBankConfigQuery } from "../../hooks/useGetSchoolBankConfigQuery";
import { setPdfPreviewType } from "../../redux/slices/report/report";
import { resetStudentData, setStudentData } from "../../redux/slices/school/student";
import { setSubscriptionData } from "../../redux/slices/school/subscription";
import { resetUserData, setUserData } from "../../redux/slices/users/user";
import { RootState } from "../../redux/store";
import { routes } from "../../routes";
import { createPaymentReference, getReferenceCodeV2 } from "../../services/finance/paymentReference";
import { createPaymentTransaction } from "../../services/finance/paymentTransaction";
import { createStudentDebt, createStudentDebtReferences } from "../../services/finance/studentDebt";
import { getPlanSubjects } from "../../services/school/PlanSubjects";
import { createSubscription, createSubscriptionSubject } from "../../services/school/student/createSubscription";
import { getStudentByCode } from "../../services/school/student/getStudentByCode";
import { getSubjectsReprovedQuery, } from "../../services/school/subject/getSubjects";
import { getUserById } from "../../services/user/getUsers";
import { CreateStudentDebtReferenceType, PaymentReferenceType, PaymentTransactionType } from "../../types/Finance";
import { SubscriptionType } from "../../types/Student";
import { addDaysToDate, formatDateForInput } from "../../utils/dateFormatter";
import { getFile } from "../../utils/fileUtils";
import { stringToBoolean } from "../../utils/utilities";
import { UserPreview } from "../Users/UserPreview";
import { CreateSubscriptionFormValidation } from "./CreateSubscriptionFormValidation";
import { GetStudentDataFormValidation } from "./GetStudentDataFormValidation";
import { IES } from "../../utils/labels";
import { useExportDocument } from "../../hooks/useExportDocument";
import { useLogoBase64 } from "../../hooks/useLogoBase64";
import { useIES } from "../../hooks/useIES";
type ActiveSegmentTab = 'user' | 'documents' | 'departament' | 'subjects' | 'subscription' | 'payments' | 'validate';

const columnNamesMapPlanSubjects: { [key: string]: string } = {
  level: 'Ano',
  semester: 'Semestre',
  subject: 'Disciplina',
  isCoreBagde: 'Nuclear/Opcional',
};

export const CreateSubscription = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data: currentYear } = useGetCurrentAcademicYearQuery();

  const navigate = useNavigate();

  const [activeSegment, setActiveSegment] = useState<ActiveSegmentTab>('user');
  const studentData = useSelector((state: RootState) => state.student.student);
  const userData = useSelector((state: RootState) => state.user);
  const mutationCreateSubscription = useMutation({ mutationFn: createSubscription, mutationKey: "createSubscription" })
  const mutationCreateSubscriptionSubject = useMutation({ mutationFn: createSubscriptionSubject, mutationKey: "createSubscriptionSubject" })
  const mutationSaveReferenceCode = useMutation({ mutationFn: createPaymentReference, mutationKey: 'createPaymentReference' });
  const mutationCreatePaymentTransaction = useMutation({ mutationFn: createPaymentTransaction, mutationKey: 'createPaymentTransaction' });
  const { exportDocument } = useExportDocument()
  const {logoBase64} = useLogoBase64();
  const { IES, isLoading } = useIES();
  const loginData = useSelector((state: RootState) => state.login.userData)
  const { data: schoolBankConfigsData, status: schoolBankConfigsStatus, isError: isErrorSchoolschoolBankConfigs, isLoading: isLoadingSchoolschoolBankConfigs } = useGetSchoolBankConfigQuery({ PageNumber: 1, PageSize: 400 });
  const { data: paymentTypesData, status: paymentTypesStatus, isError: isErrorPaymentTypes, isLoading: isLoadingPaymentTypes } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });
  const subscriptionData = useAppSelector((state) => state.student);
  const mutationCreateStudentDebt = useMutation({ mutationFn: createStudentDebt, mutationKey: 'createStudentDebt' });
  const { data: scholarshipsData, status: scholarshipsStatus } = useGetScholarshipsQuery({ PageNumber: currentPage, PageSize: currentPage, IdStudent: studentData?.id }, {
    enabled: !!studentData?.id,
    refetchOnWindowFocus: false,
    retry: false
  });

  const dispatch = useAppDispatch();
  const defaultValues = {
    studentCode: '',

  };
  const { control, handleSubmit, setValue, getValues, formState: { errors }, watch, reset } = useForm({
    resolver: yupResolver(GetStudentDataFormValidation),
    defaultValues,
    mode: 'onBlur',
  });


  const { control: controlSubscription, handleSubmit: handleSubmitCreateSubscription, getValues: getValuesCreateSubscription, setValue: setValueCreateSubscription, formState: { errors: errorsCreateSubscription }, watch: watchCreateSubscription, trigger: triggerCreateSubscription, resetField: resetFieldCreateSubscription } =
    useForm<{
      level: number,
      semester: number,
      year: number,
      subjects?: any[]
      subjectsSubscriptions?: any[],
      payment?: {
        isPaymentByEntityReference?: boolean
        entity?: string
        totalPrice?: string | number
        reference?: string,
        idStudentDebt?: string,
        paymentProofSubscription?: any
        paymentProofPerSubject?: any
        paymentProof?: any
        idBankEntity?: string,
        idPaymentTypeSubscription?: string,
        idPaymentTypePerSubject?: string,
        idPaymentTypeMonograph?: string,
      },
      bankEntity?: string,
      isGenerateMonthly?: boolean,
      paymentTypeId?: string,
    }>({
      resolver: yupResolver(CreateSubscriptionFormValidation),
      defaultValues: {
        isGenerateMonthly: false,
        level: 0,
        semester: 0,
        year: 0,
        subjects: [],
        subjectsSubscriptions: [],
        payment: {
          paymentProof: null,
          isPaymentByEntityReference: true
        }
      },
      mode: 'onBlur',
    });

  const handleChangeLevelCreateSubscription = (value: string) => {

    setValueCreateSubscription('subjectsSubscriptions', []);

    setValueCreateSubscription('level', +value);

    const semesterValue = getValuesCreateSubscription('semester');
    if (+semesterValue !== 0 && +value !== 0) {
      refreshPlanSubjects();
    }

    setValueCreateSubscription('year', +value);
  };

  const handleChangeSemesterCreateSubscription = (value: string) => {

    setValueCreateSubscription('subjectsSubscriptions', []);

    setValueCreateSubscription('semester', +value);

    const levelValue = getValuesCreateSubscription('level');
    if (+levelValue !== 0 && +value !== 0) {
      refreshPlanSubjects();
    }
  };

  const { isLoading: isLoadingGetStudent, refetch: fetchStudentByCode, isError: isErrorGetStudent, error } = useQuery(
    ['getStudentByCode'],
    async () => {
      const studentCodeValue = getValues('studentCode');

      // if (studentCodeValue.trim().length < 17) return;
      try {
        const studentData = await getStudentByCode(studentCodeValue);
        if (!studentData) return;
        const userData = await getUserById(studentData.idUser)
        if (!userData) return;
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
        if (studentCodeValue) {
          fetchReprovedSubjects();
        }

      } catch (error) {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  );
  const handleStudentCodeChange = useCallback(
    debounce((value: string) => {
      const trimmedValue = value.trim();
      setValue('studentCode', trimmedValue);
      if (trimmedValue.length >= 3) {
        fetchStudentByCode();
      } else {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    }, 300),
    [setValue, fetchStudentByCode]
  );
  const { data: reprovedSubjectsData, isLoading: isLoadingReprovedSubjects, refetch: fetchReprovedSubjects, isError: isErrorReprovedSubjects, status: reprovedSubjectsStatus } =
    useQuery(
      ['getSubjectsReprovedQuery', `${studentData?.id}`],
      async () => {
        try {
          const data = await getSubjectsReprovedQuery({ PageNumber: currentPage, PageSize: 400, IdStudent: `${studentData?.id}`, Year: currentYear?.year, Semester: getValuesCreateSubscription('semester') });
          return data;
        }
        catch {

        }

      },
      {
        enabled: !!studentData?.id && !!getValuesCreateSubscription('semester'),
        refetchOnWindowFocus: false,
        retry: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {

  })

  const onSubmitCreateSubscription = handleSubmitCreateSubscription(async (data) => {
    try {
      let referenceCode;
      let studentDebtData;
      let idSubscription;
      let dataToPrint;
      const createSubscriptionRequest: SubscriptionType = {
        ...data, idEnrollment: `${studentData?.idEnrollment}`,
        idAcademicYear: currentYear?.id,
        status: true, reason: "",
        student: userData.name,
        studentCode: getValues('studentCode'),
        academicYear: currentYear?.year
        , idValidated: true
      };
      const resultCreateSubscription = await mutationCreateSubscription.mutateAsync(createSubscriptionRequest)
      if (!resultCreateSubscription) return;
      dataToPrint = { ...createSubscriptionRequest, id: resultCreateSubscription };
      try {
        idSubscription = resultCreateSubscription;
        const subscriptionSubjects = allAvailableSubjects.map(s => {
          return {
            ...s,
            status: true,
            idSubscription: resultCreateSubscription,
          }
        });
        await Promise.all(subscriptionSubjects.map((cv) => {
          if (cv) {
            return mutationCreateSubscriptionSubject.mutateAsync(cv)
          }
        }))
        try {
          const uniqueSubjects = Array.from(
            new Set(subscriptionSubjects.map(subject => subject.idSubject))
          ).map(idSubject =>
            subscriptionSubjects.find(subject => subject.idSubject === idSubject)
          );

          let amountToPay = 0;
          const subscriptionAmount = paymentTypesData?.items.find((paymentType) => paymentType.id === data?.payment?.idPaymentTypeSubscription!)?.amount ?? 0;
         
          if (isSubscriptionPaymentTypeValid) {
              amountToPay += amountToPayPaymentTypeSubscription;
          }else{
            amountToPay += subscriptionAmount;
          }

          const subjectsAmount = paymentTypesData?.items.find((paymentType) => paymentType.id === data?.payment?.idPaymentTypePerSubject!)?.amount ?? 0;
          const subjectsTotal = uniqueSubjects.filter((ss: any) => !(stringToBoolean(ss?.isMonograph))).length * subjectsAmount;
         
          if(isPerSubjectPaymentTypeValid){
            amountToPay += amountToPayPaymentTypePerSubject;
          }else{

            amountToPay += subjectsTotal;
          }

          const subjectsMonographAmount = paymentTypesData?.items.find((paymentType) => paymentType.id === data.payment?.idPaymentTypeMonograph)?.amount ?? 0;
          const subjectMonograph = (uniqueSubjects?.filter((ss: any) => (stringToBoolean(ss?.isMonograph))).length ?? 0) * subjectsMonographAmount;
         
          if(isMonographPaymentTypeValid){
            amountToPay += amountToPayPaymentTypeMonograph;
          }else{
            amountToPay += subjectMonograph;
          }

          studentDebtData = {
            idStudent: studentData?.id ?? "",
            fullname: userData.name.concat(" ").concat(studentData?.schoolCode ?? "") ?? "",
            idPaymentType: data.payment?.idPaymentTypeSubscription!,
            originalAmount: amountToPay,
            currentAmount: amountToPay,
            dueDate: formatDateForInput(addDaysToDate(new Date(), 30).toISOString()),
            isPayed: stringToBoolean(data.payment?.isPaymentByEntityReference) ? false : true,
            description: paymentTypesData?.items.find((paymentType) => paymentType.id === data?.payment?.idPaymentTypeSubscription!)?.description ?? "Inscrição",
            idSubscription: idSubscription,
            idsSubjects: JSON.stringify(uniqueSubjects.map((s: any) => s.idSubject)),
          }
          const resultCreateStudentDebt = await mutationCreateStudentDebt.mutateAsync(studentDebtData);
          studentDebtData = { ...studentDebtData, id: resultCreateStudentDebt };


          if (amountToPay > 0) {
            if (stringToBoolean(getValuesCreateSubscription('payment.isPaymentByEntityReference'))) {
              const currentDate = new Date();
              try {
                referenceCode = await getReferenceCodeV2({
                  amount: studentDebtData.currentAmount,
                  idStudent: studentDebtData.idStudent,
                  idPaymentType: studentDebtData.idPaymentType,
                  idStudentDebt: studentDebtData.id,
                  month: (currentDate.getMonth() + 1).toString(),
                  year: currentDate.getFullYear().toString(),
                  description: studentDebtData.description,
                  idBankEntity: data?.payment?.idBankEntity,
                  entity: String(schoolBankConfigsData?.items.find(i => i.id === getValuesCreateSubscription('payment.idBankEntity'))?.bankEntity)
                });
                const paymentReference: PaymentReferenceType = {
                  idStudent: studentDebtData.idStudent,
                  idPaymentType: studentDebtData.idPaymentType,
                  amount: studentDebtData.currentAmount,
                  dueDate: new Date(studentDebtData.dueDate).toISOString(),
                  referenceCode: referenceCode,
                  idStudentDebt: studentDebtData.id,
                  entity: String(schoolBankConfigsData?.items.find(i => i.id === getValuesCreateSubscription('payment.idBankEntity'))?.bankEntity),
                  idBankEntity: data?.payment?.idBankEntity
                }
                await mutationSaveReferenceCode.mutateAsync(paymentReference)
              } catch (ex: any) {
                toast.error(ex?.message);
              }
            } else {
              const { base64 } = await getFile(data.payment?.paymentProof)
              const paymentTransaction: PaymentTransactionType = {
                date: new Date().toISOString(),
                idPaymentType: data.payment?.idPaymentTypeSubscription!,
                amountPaid: amountToPay ?? 0,
                idStudent: studentDebtData.idStudent,
                paymentProof: base64,
                idStudentDebt: resultCreateStudentDebt,
                idCompleted: true,
              }
              await mutationCreatePaymentTransaction.mutateAsync(paymentTransaction)
            }
          }

          dataToPrint.course = studentData?.course;
          dataToPrint.payment = {
            reference: referenceCode,
            paymentProof: data?.payment?.paymentProof ?? "",
            entity: String(schoolBankConfigsData?.items.find(i => i.id === getValuesCreateSubscription('payment.idBankEntity'))?.bankEntity),
            totalPrice: studentDebtData?.currentAmount
          }
        } catch (error) {
          console.error({ error })
        }
      } catch (error) {
        console.error({ error })
      }
      toast.success("Estudante inscrito");
      try {
        if (stringToBoolean(data.isGenerateMonthly)) {
          const createSubscriptionDebtReference: CreateStudentDebtReferenceType = {
            studentId: studentData?.id ?? "",
            studentCode: studentData?.schoolCode ?? "",
            fullname: studentData?.fullname ?? "",
            enrollmentId: studentData?.idEnrollment ?? "",
            subscriptionId: idSubscription ?? "",
            paymentTypeId: `${data.paymentTypeId}`,
            idSchoolBankConfig: `${data.bankEntity}`,
            bankEntity: `${schoolBankConfigsData?.items.find(i => i.id === data.bankEntity)?.bankEntity ?? ""}`,
            semester: data.semester ?? 1,
            year: Number(currentYear?.year) ?? Number(new Date().getFullYear()),
          }
          const references = await createStudentDebtReferences({ ...createSubscriptionDebtReference });
          toast.success("Referências criadas com sucesso!");
          const pdfPreviewTypeDataLS = 'REFERENCES';
          localStorage.setItem("pdfPreviewTypeData_REFS", pdfPreviewTypeDataLS);
          localStorage.setItem("studentDebtReferences", JSON.stringify(references));
          localStorage.setItem("studentDebtReferencesData", JSON.stringify(createSubscriptionDebtReference));
          window.open(routes.pdfPreview, "_blank");
        }

      } catch (error) {
        console.error({ error })
      }
      handleBack();
      handlePrintSubscription(dataToPrint, allAvailableSubjects)
    } catch (err: any) {

      toast.error(`${err?.message}`);

    }
  })
  const navigateAndValidate = (tabToNavigateTo: ActiveSegmentTab) => {
    if (activeSegment !== tabToNavigateTo) setActiveSegment(tabToNavigateTo);
    triggerCreateSubscription();
  }

  const handleBack = () => {
    dispatch(resetStudentData());
    dispatch(resetUserData());
    navigate(routes.subscriptions);
  }

  const { data: planSubjectsData, isLoading: isLoadingPlanSubjectsData, refetch: refreshPlanSubjects, status: planSubjectsStatus, isError: isErrorPlanSubjectsData } =
    useQuery(
      ['getPlanSubjectsQuery'],
      async () => {
        try {
          const data = await getPlanSubjects({
            PageSize: 400,
            PageNumber: 1,
            Level: undefined,
            Semester: getValuesCreateSubscription('semester'),
            IdPlan: studentData?.idPlan,
            IdCourse: studentData?.idCourse
          }
          );
          const responseData = { ...data }
          responseData.items = responseData.items.filter(i => i.level <= getValuesCreateSubscription('year')!);
          return responseData;
        } catch { }
      },
      {
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false
      }
    );
  const handlePrintSubscriptionOld = (s: SubscriptionType, subjects: any[]) => {
    s.planSubjects = subjects
    dispatch(setSubscriptionData(s));
    dispatch(setPdfPreviewType('SUBSCRIPTION'));
    navigate(routes.pdfPreview);
  };

const handlePrintSubscription = async (s: SubscriptionType, subjects: any[])  => {
    try {
      const data: any = {
        type: "SUBSCRIPTION",
        outputFormat: "DOCX",
        data: {
          ies:IES.NAME ?? "", 
          ano_lectivo: s.academicYear ?? "",
          nome_completo:subscriptionData.student?.fullname,
          codigo:s.studentCode,
          curso:s.course,
          data_emissao  : new Date().toLocaleDateString(),
          utilizador: loginData?.Fullname,
          cargo: loginData?.Role ,
          grades: subjects.map((sub, index) => ({
          ordem: index + 1,
          nome_disciplina: sub.subject,
          nivel: s.level,
          semestre: s.semester
  })),
        },
            logoBase64: logoBase64 ?? ""
      };

      await exportDocument(data, "SUBSCRIPTION");
    }catch (err) {
      console.error("Erro ao imprimir inscrição:", err);
    }
  };
  

  const watchSubjectSubscriptions = watchCreateSubscription('subjectsSubscriptions');
  const watchSubjects = watchCreateSubscription('subjects');
  const subjectSubscriptionsSelected = watchSubjectSubscriptions?.map(ss => {
    ss = JSON.parse(ss)
    return {
      idSubject: ss.idSubject,
      level: ss.level,
      semester: ss.semester,
      isCore: ss.isCore,
      idSubjectPrecedence: ss.idSubjectPrecedence,
      subject: ss.subject,
      isMonograph: ss.isMonograph
    }
  })
  const repprovedSubjectsSelected = watchSubjects?.map(ss => {
    ss = JSON.parse(ss)
    return {
      idSubject: ss.idSubject,
      level: ss.level,
      semester: ss.semester,
      isCore: ss.isCore,
      idSubjectPrecedence: ss.idSubjectPrecedence,
      subject: ss.subject,
      isMonograph: ss.isMonograph
    }
  })
  const allAvailableSubjects = [...repprovedSubjectsSelected ?? [], ...subjectSubscriptionsSelected ?? []]
  const watchPaymentType = watchCreateSubscription('payment.isPaymentByEntityReference');

  const handleOnChangePaymentType = (e: any) => {
    const paymentType = stringToBoolean(getValuesCreateSubscription('payment.isPaymentByEntityReference'))
    if (paymentType) {
      resetFieldCreateSubscription('payment.paymentProof')
    }
    if (!paymentType) {
      resetFieldCreateSubscription('payment.idBankEntity')
    }
  };

  const isGenerateMonthly = watchCreateSubscription("isGenerateMonthly");


  const idPaymentTypeSubscription = watchCreateSubscription("payment.idPaymentTypeSubscription");

  const idPaymentTypePerSubject = watchCreateSubscription("payment.idPaymentTypePerSubject");

  const idPaymentTypeMonograph = watchCreateSubscription("payment.idPaymentTypeMonograph");


  const availablePaymentTypes = JSON.parse(scholarshipsData?.items[0]?.idsPaymentTypes || "[]");


  const isSubscriptionPaymentTypeValid = availablePaymentTypes.some(
    (payment: any) => payment.idPaymentType === idPaymentTypeSubscription
  );

  const isPerSubjectPaymentTypeValid = availablePaymentTypes.some(
    (payment: any) => payment.idPaymentType === idPaymentTypePerSubject
  );

  const isMonographPaymentTypeValid = availablePaymentTypes.some(
    (payment: any) => payment.idPaymentType === idPaymentTypeMonograph
  );





  const paymentTypeSubscription = paymentTypesData?.items?.find(
    (i) => Number(i?.internalCode) === 26 && i.id === idPaymentTypeSubscription
  );

  const paymentTypePerSubject = paymentTypesData?.items?.find(
    (i) => Number(i?.internalCode) === 27 && i.id === idPaymentTypePerSubject
  );

  const paymentTypeMonograph = paymentTypesData?.items?.find(
    (i) => Number(i?.internalCode) === 28 && i.id === idPaymentTypeMonograph
  );


  const paymentInfoPaymentTypeSubscription = availablePaymentTypes.find(
    (i: any) => i.idPaymentType === paymentTypeSubscription?.id
  );

  const paymentInfoPaymentTypePerSubject = availablePaymentTypes.find(
    (i: any) => i.idPaymentType === paymentTypePerSubject?.id
  );

  const paymentInfoPaymentTypeMonograph = availablePaymentTypes.find(
    (i: any) => i.idPaymentType === paymentTypeMonograph?.id
  );


  const amountToPayPaymentTypeSubscription =
    (paymentTypeSubscription?.amount ?? 0) -
    ((paymentTypeSubscription?.amount ?? 0) * (paymentInfoPaymentTypeSubscription?.percent ?? 0)) / 100;

  const amountToPayPaymentTypePerSubject =
    (paymentTypePerSubject?.amount ?? 0) -
    ((paymentTypePerSubject?.amount ?? 0) * (paymentInfoPaymentTypePerSubject?.percent ?? 0)) / 100;

  const amountToPayPaymentTypeMonograph =
    (paymentTypeMonograph?.amount ?? 0) -
    ((paymentTypeMonograph?.amount ?? 0) * (paymentInfoPaymentTypeMonograph?.percent ?? 0)) / 100;
  return (
    <Card size='5'>
      <Flex direction='column' gap='6'>
        <form onSubmit={onSubmit} noValidate>
          <TextFieldComponent
            name="studentCode"
            label="Código do estudante"
            control={control}
            errors={errors}
            fieldProps={{
              placeholder: 'Digite o código do estudante',
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleStudentCodeChange(e.target.value),
              onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                e.preventDefault();
                const pastedText = e.clipboardData.getData('text');
                handleStudentCodeChange(pastedText);
              }
            }}
          />
        </form>
        {isLoadingGetStudent ? <Spinner loading /> :
          isErrorGetStudent ? <Flex direction="column">
            <Callout.Root color="red" role="alert">
              <Text>
                Náo foi possivel localizar o estudante
              </Text>
            </Callout.Root>

          </Flex> :
            <form onSubmit={onSubmitCreateSubscription} noValidate>
              <Card size='5'>
                <Tabs.Root value={activeSegment} onValueChange={(tabToNavigate) => {
                  navigateAndValidate(tabToNavigate as ActiveSegmentTab);
                  if (tabToNavigate.includes('subjects')) {
                    fetchReprovedSubjects();
                    refreshPlanSubjects();
                  }
                }}>
                  <Tabs.List>
                    <Tabs.Trigger value='user' >
                      Dados gerais
                    </Tabs.Trigger>
                    <Tabs.Trigger value='departament'>
                      Curso
                    </Tabs.Trigger>
                    {/* <Tabs.Trigger value='documents'>
                          Documentos 
                      </Tabs.Trigger> */}
                    <Tabs.Trigger value='subscription'>
                      Dados de inscrição
                      {errorsCreateSubscription && <Badge color="red">{Object.keys(errorsCreateSubscription)?.length} </Badge>
                      }
                    </Tabs.Trigger>
                    <Tabs.Trigger value='subjects'>
                      Disciplinas
                    </Tabs.Trigger>
                    <Tabs.Trigger value='payments'>
                      Pagamentos
                    </Tabs.Trigger>
                    <Tabs.Trigger value='validate'>
                      Validação da inscrição
                    </Tabs.Trigger>
                  </Tabs.List>
                  <Box pt="3">
                    <Tabs.Content value="user">
                      <UserPreview />
                    </Tabs.Content>
                    <Tabs.Content value="departament">
                      <Flex direction='column' gap='4'>
                        <Text weight="bold">Departamento:</Text>
                        {studentData?.departament ? (
                          <Text>{studentData?.departament}</Text>
                        ) : (
                          <Text color="gray">Nenhum departamento encontrado</Text>
                        )}

                        <Text weight="bold">Curso:</Text>
                        {studentData?.course ? (
                          <Text>{studentData?.course}</Text>
                        ) : (
                          <Text color="gray">Nenhum curso encontrado</Text>
                        )}
                      </Flex>
                    </Tabs.Content>
                    <Tabs.Content value="subjects">
                      <CheckboxGroupComponent
                        name="subjects"
                        label="Disciplinas em atraso"
                        control={controlSubscription}
                        errors={errorsCreateSubscription}
                        options={reprovedSubjectsData?.items && reprovedSubjectsData?.items?.sort((a, b) => a.level - b.level).map(reprovedSubjects => {
                          return ({ value: JSON.stringify(reprovedSubjects), label: `${reprovedSubjects.subject} - ${reprovedSubjects.semester}º Semestre` });
                        })}
                        style={{ width: '100%' }}
                        itemsError={isErrorReprovedSubjects}
                        itemsLoading={isLoadingReprovedSubjects}
                      />

                      <CheckboxGroupComponent
                        name="subjectsSubscriptions"
                        label="Disciplinas do semestre"
                        control={controlSubscription}
                        errors={errorsCreateSubscription}
                        options={planSubjectsData?.items?.sort((a, b) => a.level - b.level).map(item => {
                          const isAbleToDoEqual = reprovedSubjectsData?.items.find(rs => rs.idSubject === item.idSubjectPrecedence);
                          return {
                            value: JSON.stringify({
                              id: item.id,
                              subject: item.subject,
                              semester: item.semester,
                              idSubject: item.idSubject,
                              level: item.level,
                              idSubjectPrecedence: item.idSubjectPrecedence,
                              isCore: item.isCore,
                              isMonograph: item.isMonograph,
                            }),
                            label: `${item.subject} (${item.level}ºAno ${item.semester}ºSemestre)`.concat((item?.isCore ? (isAbleToDoEqual && isAbleToDoEqual?.id && " (Nuclear)  Não será inscrito") : (isAbleToDoEqual && isAbleToDoEqual?.id && " (Opcional)  Não será inscrito")) ?? ""),
                            isCoreBadge: item.isCore ? (
                              <>
                                <Badge color="green">Nuclear</Badge>
                                {isAbleToDoEqual && isAbleToDoEqual?.id && (
                                  <Badge color="red">Não será inscrito</Badge>
                                )}
                              </>
                            ) : (
                              <>
                                <Badge color="gray">Opcional</Badge>
                                {isAbleToDoEqual && isAbleToDoEqual?.id && (
                                  <Badge color="red">Não será inscrito</Badge>
                                )}
                              </>
                            ),
                          };
                        })}

                        style={{ width: '100%' }}
                        itemsError={isErrorPlanSubjectsData}
                        itemsLoading={isLoadingPlanSubjectsData}
                      />
                    </Tabs.Content>
                    <Tabs.Content value="subscription">
                      <Flex direction='row' gap='8'>
                        <TextFieldComponent
                          name="level"
                          label="Ano:"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          style={{ width: '100%' }}
                          fieldProps={{
                            placeholder: 'Digite o ano a que se inscreve o estudante',
                            onChange: (e: any) => handleChangeLevelCreateSubscription(e.target.value),
                          }}
                          required={true}
                        />
                        <TextFieldComponent
                          name="semester"
                          label="Semestre:"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          style={{ width: '100%' }}
                          fieldProps={{
                            placeholder: 'Digite o semestre',
                            onChange: (e: any) => handleChangeSemesterCreateSubscription(e.target.value),
                          }}
                          required={true}
                        />
                      </Flex>
                    </Tabs.Content>
                    <Tabs.Content value='payments'>
                      <Flex gap='6' direction='column'>
                        <RadioGroupComponent name="payment.isPaymentByEntityReference" label="Tipo de pagamento" control={controlSubscription} errors={errorsCreateSubscription}
                          style={{ width: '50%' }}
                          options={[
                            { value: "true", label: "Entidade Referencia" }
                            , { value: "false", label: "Comprovativo" }]}
                          fieldProps={{
                            style: { display: 'flex', flexDirection: 'row', gap: '16px' },
                            onChange: handleOnChangePaymentType
                          }}
                        />
                        <SelectComponent
                          name="payment.idBankEntity"
                          label="Entidade Bancária"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          itemsLoading={isLoadingSchoolschoolBankConfigs}
                          itemsError={isErrorSchoolschoolBankConfigs}
                          options={schoolBankConfigsData?.items?.map(item => ({
                            value: item.id!,
                            label: String(item.bankEntity!) ?? "",
                          })) ?? []}
                          style={{ width: '100%' }}
                          fieldProps={{ disabled: !stringToBoolean(watchPaymentType) }}
                        />
                        <Box>
                          <Text as="label" size="2">Comprovativo de Pagamento</Text>
                          <Controller
                            name={`payment.paymentProof`}
                            control={controlSubscription}

                            disabled={stringToBoolean(watchPaymentType)}
                            render={({ field }) => (
                              <DragAndDropFileUpload
                                onFileDrop={(file) => {
                                  field.onChange(file);
                                }}
                                label={`Arraste ou selecione o arquivo`}
                                accept="*"
                                selectedFile={field.value}
                                isReadOnly={stringToBoolean(watchPaymentType)}
                                disabled={stringToBoolean(watchPaymentType)}
                              />
                            )}
                          />
                          {errorsCreateSubscription.payment?.paymentProof && (
                            <Text color="red" size="1">{`${errorsCreateSubscription.payment.paymentProof.message}`}</Text>
                          )}
                        </Box>
                        <SelectComponent
                          name="payment.idPaymentTypeSubscription"
                          label="Valor da inscrição"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          itemsLoading={isLoadingPaymentTypes}
                          itemsError={isErrorPaymentTypes}
                          options={paymentTypesData?.items?.filter(i => Number((i?.internalCode!)) === 26).map(item => ({
                            value: item.id!,
                            label: String(`${item.description!} - ${item.amount!} Mts`) ?? "",
                          })) ?? []}
                          style={{ width: '100%' }}
                        />

                        {isSubscriptionPaymentTypeValid && (
                          <Flex align="center">
                            <Badge variant="surface" >{'Nota: Este estudante tem bolsa (na inscrição) e deverá pagar um total de '}</Badge>
                            <Separator orientation="horizontal" />
                            <Badge variant="outline" >{`${amountToPayPaymentTypeSubscription} Mts`}</Badge>
                          </Flex>
                        )}

                        <SelectComponent
                          name="payment.idPaymentTypePerSubject"
                          label="Valor por disciplina"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          itemsLoading={isLoadingPaymentTypes}
                          itemsError={isErrorPaymentTypes}
                          options={paymentTypesData?.items?.filter(i => Number((i?.internalCode!)) === 27).map(item => ({
                            value: item.id!,
                            label: String(`${item.description!} - ${item.amount!} Mts`) ?? "",
                          })) ?? []}
                          style={{ width: '100%' }}
                        />

                        {isPerSubjectPaymentTypeValid && (
                          <Flex align="center">
                            <Badge variant="surface" >{'Nota: Este estudante tem bolsa (na disciplina) e deverá pagar um total de '}</Badge>
                            <Separator orientation="horizontal" />
                            <Badge variant="outline" >{`${amountToPayPaymentTypePerSubject} Mts`}</Badge>
                          </Flex>
                        )}

                        <SelectComponent
                          name="payment.idPaymentTypeMonograph"
                          label="Valor da monografia"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          itemsLoading={isLoadingPaymentTypes}
                          itemsError={isErrorPaymentTypes}
                          options={paymentTypesData?.items?.filter(i => Number((i?.internalCode!)) === 28).map(item => ({
                            value: item.id!,
                            label: String(`${item.description!} - ${item.amount!} Mts`) ?? "",
                          })) ?? []}
                          style={{ width: '100%' }}
                          fieldProps={{ disabled: false }}
                        />

                        {isMonographPaymentTypeValid && (
                          <Flex align="center">
                            <Badge variant="surface" >{'Nota: Este estudante tem bolsa (na Monografia) e deverá pagar um total de '}</Badge>
                            <Separator orientation="horizontal" />
                            <Badge variant="outline" >{`${amountToPayPaymentTypeMonograph} Mts`}</Badge>
                          </Flex>
                        )}

                        <CheckboxComponent
                          name="isGenerateMonthly"
                          label="Deseja gerar mensalidades?"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                        />
                        <SelectComponent
                          name="bankEntity"
                          label="Entidade Bancária"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          itemsLoading={isLoadingSchoolschoolBankConfigs}
                          itemsError={isErrorSchoolschoolBankConfigs}
                          options={schoolBankConfigsData?.items?.map(item => ({
                            value: item.id!,
                            label: String(item.bankEntity!) ?? "",
                          })) ?? []}
                          style={{ width: '100%' }}
                          fieldProps={{ disabled: !stringToBoolean(isGenerateMonthly) }}
                        />
                        <SelectComponent
                          name="paymentTypeId"
                          label="Tipo de Pagamento (Emolumento)"
                          control={controlSubscription}
                          errors={errorsCreateSubscription}
                          itemsLoading={isLoadingPaymentTypes}
                          itemsError={isErrorPaymentTypes}
                          options={paymentTypesData?.items?.map(item => ({
                            value: item.id!,
                            label: String(item.description!) ?? "",
                          })) ?? []}
                          style={{ width: '100%' }}
                          fieldProps={{ disabled: !stringToBoolean(isGenerateMonthly) }}
                        />
                      </Flex>
                    </Tabs.Content>
                    <Tabs.Content value="validate">
                      <Box>
                        <Flex direction='column' gap='4'>
                          <Flex gap='7'>
                            <Flex gap='3'>
                              <Text weight="bold">Estudante:</Text>
                              <Text>{userData?.name || 'Nome não encontrado'}</Text>
                            </Flex>
                            <Flex gap='3'>
                              <Text weight="bold">Curso:</Text>
                              <Text>{studentData?.course || 'Curso não encontrado'}</Text>
                            </Flex>
                            <Flex gap='3'>
                              <Text weight="bold" >Ano:</Text>
                              <Text>{watchCreateSubscription('level') || 'Ano não especificado'}</Text>
                            </Flex>
                          </Flex>
                          <Flex gap='7'>

                            <Flex gap='3'>
                              <Text weight="bold">Semestre:</Text>
                              <Text>{watchCreateSubscription('semester') || 'Semestre não especificado'}</Text>
                            </Flex>
                          </Flex>
                          <Text weight="bold" mt="4">Resumo:</Text>
                          <Flex direction="column" gap="4" style={{ flex: 1 }}>
                            <Lists
                              status={'success'}
                              TableComponent={() =>
                                <TableComponent
                                  columns={Object.keys(columnNamesMapPlanSubjects)}
                                  items={allAvailableSubjects
                                    .map(item => {
                                      const isAbleToDoEqual = reprovedSubjectsData?.items.find(rs => rs.idSubject === item.idSubjectPrecedence)
                                      return ({
                                        ...item,
                                        isCoreBagde: item.isCore ? <>  <Badge color="green">Nuclear </Badge>{isAbleToDoEqual && isAbleToDoEqual?.id ? <><Badge color="red">Não será inscrito</Badge></> : <></>}</> : <><Badge color="gray">Opcional</Badge> {isAbleToDoEqual && isAbleToDoEqual?.id ? <><Badge color="red">Não será inscrito</Badge></> : <></>}</>,
                                      })

                                    })}
                                  options={[]}
                                  columnNamesMap={columnNamesMapPlanSubjects}
                                  totalPages={1}
                                  currentPage={1}
                                  onPageChange={() => { }}
                                />
                              }
                            />
                          </Flex>
                        </Flex>

                        <Flex mt="4" justify="end">
                          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                            <Button color='red' onClick={handleBack}
                              disabled={mutationCreateSubscription.isLoading}
                            >
                              <ChevronLeftIcon /> voltar
                            </Button>
                            <Button type="submit"
                              disabled={mutationCreateSubscription.isLoading}
                              variant='surface'>
                              {mutationCreateSubscription.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                              Registar
                            </Button>
                          </Flex>

                        </Flex>
                      </Box>
                    </Tabs.Content>
                  </Box>
                </Tabs.Root>
              </Card>
            </form>
        }

      </Flex>
    </Card>
  );
}